import { client, authHeaders } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

type GetFeatureEnabledQuery =
  paths['/api/v1/features/enabled']['get']['parameters']['query'];
type GetFeatureEnabledResponse =
  paths['/api/v1/features/enabled']['get']['responses'][200]['content']['application/json'];

export async function getFeatureEnabled(
  params: GetFeatureEnabledQuery
): Promise<GetFeatureEnabledResponse> {
  const { data, error } = await client.GET('/api/v1/features/enabled', {
    params: { query: params },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response for feature flag');
  return data;
}
